import { createAction } from '@reduxjs/toolkit';

export const footerUpdateRequest = createAction('emailsFooter/updateRequest');
export const footerUpdateError = createAction('emailsFooter/updateError');
export const footerUpdateStore = createAction('emailsFooter/updateStore');

export const footerStore = createAction('emailsFooter/store');
export const footerClear = createAction('emailsFooter/clear');

export const footerUpdateId = createAction('emailsFooter/updateId');
export const footerUpdateIsActive = createAction('emailsFooter/updateIsActive');

export const footerUpdateContent = createAction('emailsFooter/updateContent');
